import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <div className="relative pt-16">
      {/* Background Image */}
      <div
        className="!absolute inset-0 z-0"
        style={{
          backgroundImage: "url(/image/reception.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="!absolute inset-0 bg-black/40" /> {/* Overlay */}
      </div>

      <div className="relative z-10 flex flex-col items-start justify-center h-full">
        <div className="max-w-7xl mx-auto w-full pt-24 pb-16">
          <div className="bg-orange-400/90 inline-block px-8 py-4 rounded-tr-lg rounded-br-lg">
            <h1 className="text-4xl sm:text-2xl md:text-2xl font-bold text-white">
              {t("About Us")}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
